import type { ActionParams } from '@swf/components/StarsMPNotification/config/NotificationTypes';
import { dispatch } from '@swf/core/store';

import defaultHeaderImg from '../../assets/images/default-chest-header.png';
import ChestNotificationView from '../../components/ChestReward/ChestReward';
import { ActionType, FormatType } from '../../enums';

import {
  TXTCLI_View_Chests,
  TXTCLI_YouXve_been_awarded_a_ChestX,
  TXTMOB_AvailableX,
  TXTWCL_View_in_My_Rewards
} from './ChestReward.timelocked.config.messages.json';

const i18nTags = {
  title: { tag: TXTCLI_YouXve_been_awarded_a_ChestX },
  available: { tag: TXTMOB_AvailableX },
  viewMyChests: { tag: TXTCLI_View_Chests },
  viewRewards: { tag: TXTWCL_View_in_My_Rewards }
};

export default {
  front: {
    view: ChestNotificationView,
    viewConfig: {
      title: i18nTags.title,
      defaultHeaderImageURL: defaultHeaderImg,
      showCloseIcon: true,
      desktopWidth: 470,
      desktopHeight: 480,
      isGridStyled: false,
      displayAttributes: [
        {
          attrKey: 'availableOn',
          attrLabel: i18nTags.available,
          attrFormatterType: FormatType.Date
        }
      ],
      actions: [
        {
          actionType: ActionType.Primary,
          actionLabel: i18nTags.viewMyChests,
          href: '/account/my-stars/chest-inventory',
          actionFunction: ({ notificationId }: ActionParams) =>
            dispatch.notification.delete({ notificationId })
        },
        {
          actionType: ActionType.Secondary,
          actionLabel: i18nTags.viewRewards,
          href: '/account',
          actionFunction: ({ notificationId }: ActionParams) =>
            dispatch.notification.delete({ notificationId })
        }
      ]
    }
  }
};
